/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import {
	Button,
	ClickAwayListener,
	FormLabel,
	IconButton,
	Paper,
	Stack,
	Tooltip,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import BrokerageColourPicker from '@/components/BrokerageColourPicker';
const EditColourDialog = ({ block, title, handleSave, handleClose, canRemove=true }) => {
	const [value, setValue] = useState(null);

	useEffect(() => {
		console.log('Block being colour edited', block);

		setValue(
			title.toLowerCase() === 'background' ? block?.backgroundColour : block?.fontColour
		);
	}, [block?.backgroundColour]);

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<Paper elevation={1}>
				<Stack
					spacing={1}
					padding={1}
					sx={{
						'& .sketch-picker': {
							background: 'none !important',
							boxShadow: 'none !important',
							padding: '0 !important',
							borderRadius: '0 !important',
						},
					}}
				>
					<Stack direction='row' justifyContent='space-between' alignItems='center'>
						<FormLabel>{`Edit ${title} Colour`}</FormLabel>
						{canRemove && <Tooltip title={`Remove ${title.toLowerCase()} colour`}>
							<IconButton
								sx={{ fontSize: '18px', padding: '4px' }}
								onClick={() => handleSave(null)}
							>
								<DeleteForeverIcon sx={{ fontSize: '18px' }} />
							</IconButton>
						</Tooltip>}
					</Stack>
					<BrokerageColourPicker value={value} setValue={setValue} canRemove={canRemove} />
					<Stack direction='row' justifyContent='space-between' spacing={1}>
						<Button onClick={handleClose}>Cancel</Button>
						<Button
							onClick={() => {
								// console.log(
								// 	'VALUE',
								// 	value,
								// 	typeof value !== 'string' ? Object.values(value) : ''
								// );
								if (
									value &&
									typeof value !== 'string' &&
									Object.values(value).every((v) => v === 0)
								) {
									handleClose();
								} else {
									handleSave(value);
								}
							}}
							variant='contained'
						>
							Save
						</Button>
					</Stack>
				</Stack>
			</Paper>
		</ClickAwayListener>
	);
};

export default EditColourDialog;
